import React from "react";
import Container from "@material-ui/core/Container";
import {getMessage} from "../../util";


const QuestionForbidden = (props) => {


    return (
        <Container>
            {getMessage(props.meeting.meeting_type,'question_forbidden',props.messages)}
        </Container>


    )
}

export default QuestionForbidden;